import { useContextSelector as useCS } from "use-context-selector"

import { GlobalConfigContext } from "domain/globalConfig/GlobalConfigContext"
import { globalConfigSelectors } from "domain/globalConfig/selectors"

export const usePrepareChangelogDictionaries = () => {
  const { types, sources } = useCS(
    GlobalConfigContext,
    globalConfigSelectors.dictionaries
  )

  if (!types || !sources) {
    return {
      dictionaries: null,
      isError: false,
    }
  }

  return {
    dictionaries: {
      types: types.data,
      sources: sources.data,
    },
    isError: !!(types.error || sources.error),
  }
}
